import { Injectable, inject } from '@angular/core';
import { safelyCreateHttpParams } from 'src/app/core/services/api/api-utils';
import { operations } from 'src/app/core/services/api/generated/ix-api.types';
import { IxRestApi } from 'src/app/core/services/api/ix-rest-api';

@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  readonly #ixRestApi = inject(IxRestApi);

  getNotifications(
    path: operations['getNotifications']['parameters']['path'],
    query: operations['getNotifications']['parameters']['query'],
  ) {
    return this.#ixRestApi.get(
      { pathname: '/api/projects/{projectId}/notifications', options: { path } },
      { params: safelyCreateHttpParams(query) },
    );
  }

  updateNotifications(
    path: operations['updateNotifications']['parameters']['path'],
    body: operations['updateNotifications']['requestBody']['content']['application/json'],
  ) {
    return this.#ixRestApi.patch(
      { pathname: '/api/projects/{projectId}/notifications', options: { path } },
      body,
    );
  }
}
